import React from 'react';
import classNames from 'classnames';
import { BillingOption } from '../../../../utils/billing-options';
import { accessibleOnClick } from '../../../../utils/accessible-on-click';
import history from '../../../../history';
import { Routes } from '../../../../routes';
import {
  getFestiveDiscountPercentage,
  getIsFestiveDiscountActive,
} from '../../../../../components/settings/components/billing-subscription/components/outreach-plans/components/outreach-plan-card/utils/helper';

// To show quarterly plan for email outreach just uncomment the code
export const getBillingOptions = ({
  // quarterlyDiscount = 10,
  annuallyDiscount = 20,
}) => [
  { label: 'Monthly', value: BillingOption.MONTHLY },
  // { label: 'Quarterly', value: BillingOption.QUARTERLY, discount: quarterlyDiscount },
  {
    label: 'Annually',
    value: BillingOption.ANNUALLY,
    discount: annuallyDiscount,
  },
];

type IProps = {
  value: BillingOption;
  onChange: (value: BillingOption) => void;
  disabledLabel: string[] | string;
};

const PlanCycleSwitch: React.FC<IProps> = ({
  value,
  onChange,
  disabledLabel,
}) => {
  const route = history?.location?.pathname;
  const isFestiveDiscountActive = getIsFestiveDiscountActive();
  const festiveDiscountPercentage = getFestiveDiscountPercentage();
  const isEmailOutreachRoute = route.includes(
    Routes.Setting_Billing_Upgrade_Email_Outreach_Plan,
  );
  const isInboxRadarRoute = route.includes(
    Routes.Setting_Billing_Inbox_Placement_Radar,
  );

  const billingOptionClass = {
    [BillingOption.MONTHLY]: BillingOption.MONTHLY,
    [BillingOption.QUARTERLY]: BillingOption.QUARTERLY,
    [BillingOption.ANNUALLY]: BillingOption.ANNUALLY,
  };

  const getDiscountPercentage = () => {
    if (isInboxRadarRoute) {
      return {
        annuallyDiscount: 30,
      };
    }
    if (isEmailOutreachRoute) {
      return {
        annuallyDiscount: isFestiveDiscountActive
          ? festiveDiscountPercentage
          : 30,
      };
    }
    return {};
  };

  // Only show quarterly for email outreach
  const visibleOptions =
    // isEmailOutreachRoute
    //   ? billingOptions
    //   :
    getBillingOptions(getDiscountPercentage())?.filter(
      (option) =>
        option?.value === BillingOption.MONTHLY ||
        option?.value === BillingOption.ANNUALLY,
    );
  const getOptionClassNames = (option) =>
    classNames([
      'plan-cycle-switch--option',
      `${option.value}`,
      {
        selected: value === option.value,
        disabled: disabledLabel?.includes(option.label),
      },
    ]);

  return (
    <div
      // className={`plan-cycle-switch ${
      //   isEmailOutreachRoute ? 'email-outreach-plan-cycle-switch' : ''
      // }`}
      className="plan-cycle-switch"
    >
      {visibleOptions?.map((option) => (
        <div
          className={getOptionClassNames(option)}
          {...accessibleOnClick(() => {
            if (!disabledLabel?.includes(option?.label)) {
              onChange(option?.value);
            }
          })}
        >
          <span className="plan-cycle-switch--option-label">
            {option.label}
          </span>
          {option?.discount && (
            <span className={`discount-percentage ${option.value}`}>
              Save {option?.discount}%
            </span>
          )}
        </div>
      ))}

      <div
        // className={`selected-option-bg ${billingOptionClass[value]} ${
        //   isEmailOutreachRoute ? 'email-outreach-selected-option-bg' : ''
        // }`}
        className={`selected-option-bg ${billingOptionClass[value]}`}
      />
    </div>
  );
};

export default PlanCycleSwitch;
